import React from "react";
import { MovieDetails } from "./MovieDetails";
import { BackgroundVideo } from "./BackgroundVideo";

const MainMovie = () => {
  return (
    <>
      <MovieDetails />
      <BackgroundVideo />
    </>
  );
};

export default MainMovie;
